module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA80lEQVRYR8XXMQrCQBCF4ZccR0ttFAQ9QdjG01lZ2gy5hDZa6iUEGyubQQIRRER3dt5uUof8XzKwm60w8FUN3EcWQNM0o7quNwAeIrL69ZJ0QB/fARgDOIjIvBjgI35W1XXbtpcigJR4B6OMIDVOAXjiboA37gIw4skAVjwJwIybAey4CZAjHg3IFY8GhBCOACYAbqq6+Le8WnbYqJUwhLAHMANwVdVlccDgI+g+aS5E1AheM82BMAFyfAkzgI1IAjARyQAWwgVgINwAL4IC8CBogFQEFfAFcRKRaZFzwXukXzG3AO7Fj2aWrTj6f8D6UMv9T9i87CER3WWdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/back.png
// module id = 9hFI
// module chunks = 1